import { render, staticRenderFns } from "./calcVesselsSpeedInputs.vue?vue&type=template&id=061032e0&scoped=true"
import script from "./calcVesselsSpeedInputs.vue?vue&type=script&lang=js"
export * from "./calcVesselsSpeedInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061032e0",
  null
  
)

export default component.exports